import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { useActivityContext } from '../../../hooks/use-activity.context';
import { FinishLessonAction } from '../../../interfaces';
import { NextLessonButtonType } from '../../../interfaces/next-lesson-button-type';
import ActivityFooter from '../../activity-footer/activity-footer';
import { Button } from '../../button/button';
import { isBigScreen } from '../../media-query';
import SecondaryButton from '../../secondary-button/secondary-button';

interface SectionCompleteFooterProps {
  extraButtonType?: NextLessonButtonType | undefined;
}

const extraButtonLeftIcon = {
  [NextLessonButtonType.UNIT_INDEX]: 'list',
};

const extraButtonRightIcon = {
  [NextLessonButtonType.NEXT_LESSON]: 'arrow-right',
  [NextLessonButtonType.NEXT_UNIT]: 'arrow-right',
};

const extraButtonTitle = {
  [NextLessonButtonType.NEXT_LESSON]: 'sectionComplete.nextLesson',
  [NextLessonButtonType.NEXT_UNIT]: 'sectionComplete.nextUnit',
  [NextLessonButtonType.UNIT_INDEX]: 'lp.unitIndex.pageTitle',
};

const SectionCompleteFooter: React.FC<SectionCompleteFooterProps> = ({
  extraButtonType,
}) => {
  const { t } = useTranslation();
  const { finishLesson } = useActivityContext();

  const handleFinishLesson = () => {
    if (extraButtonType === NextLessonButtonType.UNIT_INDEX) {
      finishLesson(FinishLessonAction.UNIT_INDEX);
    } else {
      finishLesson(FinishLessonAction.NEXT_LESSON);
    }
  };

  return (
    <ActivityFooter>
      <ActivityFooter.ButtonContainer style={styles.footerContainer}>
        <SecondaryButton
          containerStyle={styles.activityFooterButton}
          onPress={() => finishLesson(FinishLessonAction.MORE_LESSONS)}
          iconLeft="home"
        >
          {t('sectionComplete.moreLessons')}
        </SecondaryButton>

        {!!extraButtonType && (
          <Button
            containerStyle={styles.activityFooterButton}
            onPress={handleFinishLesson}
            iconRight={extraButtonRightIcon[extraButtonType]}
            iconLeft={extraButtonLeftIcon[extraButtonType]}
          >
            {t(extraButtonTitle[extraButtonType])}
          </Button>
        )}
      </ActivityFooter.ButtonContainer>
    </ActivityFooter>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  activityFooterButton: {
    width: isBigScreen() ? 300 : 220,
    marginHorizontal: isBigScreen() ? 20 : 0,
    marginBottom: 10,
    marginTop: isBigScreen() ? 10 : 0,
  },
});

export default SectionCompleteFooter;
